module.exports = __webpack_public_path__ + "img/wave_top_mobile.7f4233c9.png";